module.exports = __webpack_public_path__ + "img/coffret-huitres-en-ligne-boutrais-small.ac214180.png";